import React, { useState } from 'react';
import {
  Animated,
  Pressable,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import * as Animatable from 'react-native-animatable';
import Colors from '../../constants/Colors';
import DownArrow24 from '../24pxIcons/DownArrow24';
import IssueSettingRow from './IssueSettingRow';
import TemplateSubIcon from '../24pxIcons/TemplateSubIcon';
import NewSwitch from '../NewSwitch';
import { logEvent } from '../LogEvent';
import isMobile from '../IsMobile';

export default function NotificationGroupCard({ title, issues, groupId }: {
  title: string; issues: any[], groupId: string }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [allToggled, setAllToggled] = useState(null);
  const showSwitches = false;

  return (
    <Pressable
      style={(state) => [{
        borderColor: !isMobile && (state.hovered || state.pressed)
          ? Colors.light.hereworksBlue500 : Colors.light.hereworksWhite300,
        opacity: state.pressed ? 0.5 : 1,
      }, styles.groupCard]}
      onPress={() => {
        setDrawerOpen(!drawerOpen);
        logEvent('NotificationGroupCard', `Drawer_${drawerOpen ? 'Close' : 'Open'}`);
      }}
      testID='um-expand-notification-user-group-btn'
    >
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <TemplateSubIcon style={{ marginLeft: 16 }} />
        <Text style={styles.groupName}>{title}</Text>
        <DownArrow24
          style={[
            { position: 'absolute', right: 20 },
            drawerOpen ? { transform: [{ rotateZ: '180deg' }] } : {},
          ]}
        />
      </View>
      <Animated.View style={{ backgroundColor: 'transparent' }}>
        {drawerOpen && (
          <Animatable.View animation={'fadeIn'} duration={200}>
            {(
              <View style={{ marginBottom: 16 }}>
                <View
                  style={{
                    height: isMobile ? 0 : 1,
                    backgroundColor: Colors.light.hereworksWhite500,
                    marginBottom: 10,
                  }}
                />
                <View style={{ flexDirection: 'row' }}>
                  <Text style={styles.description}>NOTIFICATIONS</Text>
                  {showSwitches && (
                    <View style={{ flex: 1, justifyContent: 'flex-end', flexDirection: 'row' }}>
                      <Text style={styles.description}>ALL</Text>
                      <TouchableOpacity
                        onPress={() => {
                          if (allToggled || allToggled === null) {
                            setAllToggled(false);
                          } else {
                            setAllToggled(true);
                          }
                        }}
                        style={{ marginRight: 16 }}
                      >
                        <NewSwitch
                          isToggled={allToggled ?? true}
                          color={Colors.light.hereworksGreen400}
                          style={{ marginLeft: 10 }}
                        />
                      </TouchableOpacity>
                    </View>
                  )}
                </View>
                {issues.map((issue, key) => {
                  if (!issue.UserGroupId.includes(groupId)) {
                    return null;
                  }
                  return (<View key={key} style={{ marginHorizontal: 16 }}>
                    <IssueSettingRow title={issue.Text} toggled={allToggled ?? true} />
                  </View>);
                })}
              </View>
            )}
          </Animatable.View>
        )}
      </Animated.View>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  groupCard: {
    backgroundColor: isMobile ? '#fff' : Colors.light.hereworksWhite100,
    alignSelf: 'stretch',
    marginVertical: isMobile ? 0 : 8,
    borderRadius: 16,
    borderWidth: isMobile ? 0 : 1,
    borderBottomWidth: 1,
    flex: 1,
  },
  groupName: {
    fontSize: isMobile ? 14 : 18,
    fontFamily: isMobile ? 'Poppins_500Medium' : 'Poppins_600SemiBold',
    marginLeft: 12,
    marginVertical: 16,
    width: 200,
  },
  title: {
    fontSize: 18,
    fontFamily: 'Poppins_500Medium>',
    marginLeft: 24,
  },
  description: {
    fontFamily: 'Roboto_500Medium',
    fontSize: 12,
    lineHeight: 22,
    color: Colors.light.hereworksBlack400,
    marginLeft: 20,
  },
});
